//replaces graph.html
import type { FC } from "react";

import { NgToReactChart } from "app/components/React/NgToReactChart/NgToReactChart";

import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

export const GraphTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget, setChart } = props;

    function handleSetChart(chartRef) {
        setChart?.(chartRef);
    }

    return widget.chartConfig.series.length && widget.widgetState === 2 ? (
        <div
            style={{ position: "relative" }}
            className="chartContainer"
        >
            <NgToReactChart
                highchartsNgConfig={widget.chartConfig}
                afterRender={widget.afterRender}
                chartIdForAnnotations={widget.viewOptions.chartIdForAnnotations}
                setChart={handleSetChart}
            />
        </div>
    ) : null;
};
